import { apiConfig, appConfig } from '@oneview/config';
import { browserTracingIntegration } from '@sentry/browser';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Root } from './components/Root';
import { history, persistor, store } from './redux';
import './styles/global.scss';
import './index.css';
import { isDevelopment } from './utils/branchUtils';

if (!isDevelopment()) {
    Sentry.init({
        dsn: apiConfig.sentryDns,
        environment: appConfig.appEnv,
        ignoreErrors: ['Unauthorized', 'ChunkLoadError', 'AxiosError'],
        integrations: [browserTracingIntegration()],
        tracesSampleRate: apiConfig.sentrySampleRate,
    });

    const scope = Sentry.getCurrentScope();
    scope.setTag('app.version', appConfig.appVersion);
    scope.setTag('app.buildNumber', appConfig.appBuildNumber);
}

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<Root store={store} history={history} persistor={persistor} />);
